class Cactus {
  constructor(scene, i) {
    this.hasCollided = false;
    this.scene = scene;
    this.sprite = scene.physics.add
      .sprite(1300 + (100*i), 470, "cactus", 0)
      .setScale(6)
      .setSize(3,25)
      .setCollideWorldBounds(true)
      .setDepth(100);

    this.sprite.body.customBoundsRectangle.left = -1000;
    this.sprite.body.customBoundsRectangle.right = 2000;

    this.collider = scene.physics.add.collider(
      scene.player.sprite,
      this.sprite,
      this.gameOver,
      null,
      this
    );
    this.update(this.scene.state.xVelocity);
  }

  update(xVelocity) {
    this.sprite.setVelocityX(xVelocity);
  }

  stop() {
    this.sprite.setVelocityX(0);
  }

  gameOver() {
    this.scene.player.die()
    if (!this.hasCollided) {
      this.scene.state.sounds.gameOver.play(); 
      this.scene.player.sprite.play('dead', true)
      this.hasCollided = true;
      console.log("game over!");
      this.scene.player.die();
    }
  } 
}

export default Cactus;
